var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79321 3.54036C8.04705 3.7942 8.04705 4.20575 7.79321 4.45959L4.90283 7.34998H12.6669C13.0259 7.34998 13.3169 7.64099 13.3169 7.99998C13.3169 8.35896 13.0259 8.64998 12.6669 8.64998H4.90283L7.79321 11.5404C8.04705 11.7942 8.04705 12.2058 7.79321 12.4596C7.53937 12.7134 7.12782 12.7134 6.87397 12.4596L2.87397 8.4596C2.75208 8.3377 2.68359 8.17237 2.68359 7.99998C2.68359 7.82759 2.75208 7.66225 2.87397 7.54036L6.87398 3.54036C7.12782 3.28652 7.53937 3.28652 7.79321 3.54036Z",
    fill: "currentColor"
  })));
};
export default SvgArrowLeft;